import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-skeleton-condition-card',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './skeleton-condition-card.component.html',
  styleUrls: ['./skeleton-condition-card.component.scss'],
})
export class SkeletonConditionCardComponent {}
